export function parseBuildMode(value: string | undefined) {
  switch (value) {
    case 'development':
    case 'production':
      return value;
    case undefined: return 'development' as const;
    default: throw new Error('invalid build mode');
  }
}

export function parseDeploymentStage(value: string | undefined) {
  switch (value) {
    case 'local':
    case 'staging':
    case 'production':
      return value;
    case undefined: return 'local' as const;
    default: throw new Error('invalid app deployment');
  }
}